import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CustomLoadingService } from 'src/app/service/custom-loading.service';
import { ObjetService } from 'src/app/service/objet.service';
import { PdfService } from 'src/app/service/pdf.service';
import { PlanDeTraitementService } from 'src/app/service/planDeTraitement.service';
import { SiteRCCService } from 'src/app/service/site-rcc.service';
import { UserService } from 'src/app/service/user.service';
import { Context } from 'src/app/shared/services/context.service';
import { DentComponent } from '../dent/dent.component';
import * as pdfjsLib from 'pdfjs-dist';
@Component({
  selector: 'app-aligneur',
  templateUrl: './aligneur.component.html',
  styleUrls: ['./aligneur.component.scss'],
})
export class AligneurComponent implements OnInit {
  ageString: string = "";
  userSelected: string = "";
  userDetails: any;
  age: { years: number; months: number } = {years: 0, months: 0};
  idUser: string;
 @Input("traitementId") traitementId?: number; // Si tu veux passer en Input
 @Input("traitementAligneur") traitementAligneur?:any; // Si tu veux passer en Input
 @Output() nextStepEvent = new EventEmitter<void>();
 @Input() listeoftraitement: any[] = []; // 👈 reçoit les données du parent


   @Input() currentStep: number = 1;  // Valeur reçue du parent
 

 
  @ViewChild(DentComponent, { static: false }) dentComponent!: DentComponent;
  currentDate: string;
  isDisabled: boolean = false;
  isLoading: boolean = false;
  old_plan_de_traitement: any = null;
  showSpinner: boolean = false;
  isResponseValid: boolean = false;
  traitement: any;
  id: any = null;
  praticien: any;
  
  constructor(private userService: UserService,private pdfService: PdfService, private objetService: ObjetService, 
    private customLoading: CustomLoadingService,
    private siteRCCService: SiteRCCService,
    private planDeTraitementService : PlanDeTraitementService,
  )
    {     const today = new Date();
    this.currentDate = today.toLocaleDateString('fr-FR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    // this.dentComponent = new DentComponent();
  }
  objets = {
    pkObjet: 0,
    nom: "",
    extension: "",
    id_patient: 0,
    vignette: "",
    width: 0,
    height: 0,
    taille: 0,
    estidentite: 0,
    dateCreation: "",
    echelle: 0,
    fichier: "",
    lastModif: "",
    repStockage: "",
    syncPath: "",
    dateInsertion: "",
    auteur: "",
    idGabarit: "",
    id_patient_orthalis: "",
  };
  ngOnInit() {
    let value = localStorage.getItem("currentUser");
    this.praticien = JSON.parse(value);
    this.idUser = localStorage.getItem("idPatient");
    console.log('this.idUser',this.idUser);
    console.log('traitementId',this.traitementId);
    if (this.idUser != null) {
      this.getUserSelectedDetails(this.idUser);
    };
    if (this.traitementId) {
      this.loadTraitement(this.traitementId);
    }
  }

loadTraitement(id: number) {
  this.showSpinner = true;

  try {
    const data = this.traitementAligneur;
    if (!data) {
      console.warn("Aucun traitement trouvé pour cet ID :", id);
      this.showSpinner = false;
      return;
    }

    console.log("Traitement chargé:", data);

    // Champs simples
    this.id = data.id ? data.id : null;
    this.selectedValues[0] = data.marqueLaboratoire ? data.marqueLaboratoire : "";
    this.selectedValues[1] = data.etapeDeTraitement ? data.etapeDeTraitement : "";
    this.selectedValues[2] = data.arcadesATraiter ? data.arcadesATraiter : "";
    this.selectedValues[3] = data.nombreAligneurs ? data.nombreAligneurs : "";
    this.selectedValues[4] = data.portPrevu ? data.portPrevu : "";
    this.selectedValues[5] = data.changementPervu ? data.changementPervu : "";
    this.selectedValues[6] = data.haut ? data.haut : "";
    this.selectedValues[7] = data.bas ? data.bas : "";
    this.remarks = data.comment ? data.comment : "";

    // Champs auxiliaires
    this.selectedAuxiliaireVertical = data.verticalAuxiliary ? data.verticalAuxiliary : null;
    this.selectedAuxiliaireAnteroPost = data.anteroPosteriorAuxiliary ? data.anteroPosteriorAuxiliary : null;

    // 🦷 Reconstruction des sections
    if (data.dentSelections && Array.isArray(data.dentSelections)) {
      for (let i = 0; i < this.sections.length; i++) {
        const section = this.sections[i];
        let matchedSection: any = null;

        // Trouver la section correspondante dans les données
        for (let s = 0; s < data.dentSelections.length; s++) {
          if (data.dentSelections[s].title === section.title) {
            matchedSection = data.dentSelections[s];
            break;
          }
        }

        if (matchedSection) {
          // 🔹 Mise à jour des boutons
          if (section.buttons && Array.isArray(section.buttons)) {
            for (let j = 0; j < section.buttons.length; j++) {
              const button = section.buttons[j];
              let matchedButton: any = null;

              if (matchedSection.buttons && Array.isArray(matchedSection.buttons)) {
                for (let b = 0; b < matchedSection.buttons.length; b++) {
                  if (matchedSection.buttons[b].label === button.label) {
                    matchedButton = matchedSection.buttons[b];
                    break;
                  }
                }
              }

              button.selected = matchedButton && matchedButton.selected === true;
              button.variable = (matchedButton && matchedButton.variable && Array.isArray(matchedButton.variable))
                ? matchedButton.variable
                : [];
            }
          }

          // 🔹 Mise à jour des boutons secondaires
          if (section.buttons2 && Array.isArray(section.buttons2)) {
            for (let k = 0; k < section.buttons2.length; k++) {
              const button2 = section.buttons2[k];
              let matchedButton2: any = null;

              if (matchedSection.buttons2 && Array.isArray(matchedSection.buttons2)) {
                for (let b2 = 0; b2 < matchedSection.buttons2.length; b2++) {
                  if (matchedSection.buttons2[b2].label === button2.label) {
                    matchedButton2 = matchedSection.buttons2[b2];
                    break;
                  }
                }
              }

              button2.selected = matchedButton2 && matchedButton2.selected === true;
            }
          }
        }
      }
    }

    // 🎯 Récupération des variables sélectionnées
    this.selectedVariable = [];
    for (let i = 0; i < this.sections.length; i++) {
      const section = this.sections[i];
      if (section.buttons && Array.isArray(section.buttons)) {
        for (let j = 0; j < section.buttons.length; j++) {
          const btn = section.buttons[j];
          if (btn.selected && btn.variable && Array.isArray(btn.variable)) {
            this.selectedVariable = this.selectedVariable.concat(btn.variable);
          }
        }
      }
    }

    // Si aucune variable n’est sélectionnée
    if (!this.selectedVariable || this.selectedVariable.length === 0) {
      this.selectedVariable = [];
    }

    console.log("Sections rechargées :", this.sections);
    console.log("Variables sélectionnées :", this.selectedVariable);
  } catch (error) {
    console.error("Erreur lors du chargement du traitement :", error);
  } finally {
    this.showSpinner = false;
  }
}




  getAuxiliaire(key: string): string {
    return this.oldselectedValues['7'].value[key] || '-';
  }

  getPlantDeTraitement(id: any) {
    this.showSpinner = true;

    this.planDeTraitementService.getListPlanDeTraitements(id).subscribe({
      next: (response: any[]) => {
        console.log("response : ", response);
        if (response && response.length > 0) {
          this.listeoftraitement = []; // on vide l'ancien historique
          for (let i = response.length - 1; i >= 0; i--) {
            this.listeoftraitement.push(response[i]);
          }
// this.listeoftraitement.unshift(response);
          // response.forEach((traitement: any) => {
          //   this.isResponseValid = true;

          //   // 🧩 On construit une copie de la structure de résumé
          //   const traitementClone: any[] = JSON.parse(JSON.stringify(this.oldselectedValues));

          //   // ⚙️ Remplissage des valeurs simples
          //   traitementClone[0].value = traitement.marqueLaboratoire || "";
          //   traitementClone[1].value = traitement.etapeDeTraitement || "";
          //   traitementClone[2].value = traitement.arcadesATraiter || "";
          //   traitementClone[3].value.value = traitement.nombreAligneurs || "";
          //   traitementClone[4].value = traitement.portPrevu || "";
          //   traitementClone[5].value = traitement.changementPervu || "";
          //   traitementClone[3].value.Haut = traitement.haut || "";
          //   traitementClone[3].value.Bas = traitement.bas || "";

          //   // 🦷 Mise à jour des sections (nouveau format)
          //   if (traitement.dentSelections && Array.isArray(traitement.dentSelections)) {
          //     this.sections.forEach(section => {
          //       const matchedSection = traitement.dentSelections.find(
          //         (s: any) => s.title === section.title
          //       );
          //       if (matchedSection && matchedSection.buttons) {
          //         section.buttons.forEach(button => {
          //           const matchedButton = matchedSection.buttons.find(
          //             (b: any) => b.label === button.label
          //           );
          //           button.selected = matchedButton ? matchedButton.selected : false;
          //         });
          //       }
          //     });
          //   }

          //   // Ajouter la structure mise à jour dans les anciennes valeurs
          //   traitementClone[6] = JSON.parse(JSON.stringify(this.sections));

          //   // 🎯 Champs auxiliaires et autres infos
          //   traitementClone[7].value["Sens Vertical"] = traitement.verticalAuxiliary || "";
          //   traitementClone[7].value["Sens Antéro Postérieur"] = traitement.anteroPosteriorAuxiliary || "";
          //   traitementClone[8] = traitement.dateCreation || "";
          //   traitementClone[9] = traitement.comment || "";
          //   traitementClone[10] = traitement.id;
          //   traitementClone[11] = traitement.history;

          //   // 🧮 Ajout à la liste des traitements
          //   this.listeoftraitement.unshift(traitementClone);
          // });

          console.log("listeoftraitement:", this.listeoftraitement);
        } else {
          console.warn("Aucune donnée trouvée pour ce patient.");
        }

        this.currentStep++;
        this.showSpinner = false;
      },
      error: (err) => {
        console.error("Erreur lors du chargement des plans :", err);
        this.showSpinner = false;
      }
    });
  }


  insertObjet(
    nom,
    extension,
    id_patient1,
    vignette,
    width,
    height,
    taille,
    estidentite,
    dateCreation,
    echelle,
    fichier,
    lastModif,
    repStockage,
    syncPath,
    dateInsertion,
    auteur,
    idGabarit,
    id_patient_orthalis
  ) {
    this.objets["nom"] = nom;
    this.objets["extension"] = extension;
    this.objets["id_patient"] = id_patient1;
    this.objets["vignette"] = vignette;
    this.objets["width"] = width;
    this.objets["height"] = height;
    this.objets["taille"] = taille;
    this.objets["estidentite"] = estidentite;
    this.objets["dateCreation"] = dateCreation;
    this.objets["echelle"] = echelle;
    this.objets["fichier"] = fichier;
    this.objets["lastModif"] = lastModif;
    this.objets["repStockage"] = repStockage;
    this.objets["syncPath"] = syncPath;
    this.objets["dateInsertion"] = dateInsertion;
    this.objets["auteur"] = auteur;
    this.objets["idGabarit"] = idGabarit;
    this.objets["id_patient_orthalis"] = id_patient_orthalis;

    return this.objetService.addObjet(this.objets);
  }

  async getUserSelectedDetails(id) {
    this.userService.getUserById(id).subscribe(res => {
      this.showSpinner = true;
      this.userDetails = res;
      this.userSelected = this.userDetails.per_nom + " " + this.userDetails.per_prenom
      console.log('this.userDetails',this.userDetails );
      this.calculateAge(this.userDetails.per_datnaiss);
      this.ageString = `, ${this.age.years} ans, ${this.age.months} mois`;
      console.log('this.ageString',this.ageString);
      this.showSpinner = false;


    });
  }  
  calculateAge(dateString: string) {
    // Parse the date string into a Date object
    const birthDate = new Date(dateString);

    // Get the current date
    const currentDate = new Date();

    // Calculate the difference in milliseconds
    const diffMilliseconds = currentDate.getTime() - birthDate.getTime();

    // Convert the difference to years and months
    const ageInYears = Math.floor(diffMilliseconds / (1000 * 60 * 60 * 24 * 365));
    const ageInMonths = Math.floor((diffMilliseconds % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24 * 30));

    // return { years: ageInYears, months: ageInMonths };
    this.age.years = ageInYears;
    this.age.months = ageInMonths;
    
}

  // Define the questions and options
  questions = [
    {
      id: 1,
      title: '1ère QUESTION',
      resume: 'Marque',
      subtitle: 'Marque laboratoire',
      options: ['B And Smile','Smilers','Home made','Invisalign SPARK','Angel Align' ]
    },
    {
      id: 2,
      title: '2ème QUESTION',
      resume: 'Set',
      subtitle: 'Étape de Traitement',
      options: ['Début ou 1er SET', '2ème Set', '3ème Set', '4ème Set', '5ème Set', '6ème Set', '7ème Set', 'CONTENTION']
    },
    {
      id: 3,
      title: '3ème QUESTION',
      resume: 'Arcades',
      subtitle: 'Arcades à Traiter',
      options: ['Les 2', 'Haut', 'Bas']
    },
    {
      id: 4,
      title: '4ème QUESTION',
      resume: 'Nombre',
      subtitle: 'Nombre aligneurs souhaités',
      options: [
        { label: 'Forfait et protocoles', type: 'button' },
        { label: 'Haut', type: 'number' },
        { label: 'Bas', type: 'number' }
      ]
    },
    {
      id: 5,
      title: '5ème QUESTION',
      resume: 'Port',
      subtitle: 'Port prévu',
      options: ['Jour et nuit', 'Nuit', 'Nuit et Week End']
    },
    {
      id: 6,
      title: '6ème QUESTION',
      resume: 'Fréquence ',
      subtitle: 'CHANGEMENT prévu',
      options: ['15 j', '1 semaine', '10 j', '3 semaine', '1 mois', '1 mois et demi', '2 mois']
    }
  ];

  auxiliairesVertical = [
    { label: 'PRI Bite Ramps', action: 'pri_bite_ramps' },
    { label: 'Plan molaire', action: 'plan_molaire' }
  ];
  
  auxiliairesAnteroPost = [
    { label: 'Pente classe 2', action: 'pente_classe_2' },
    { label: 'Pente classe 3', action: 'pente_classe_3' },
    { label: 'Wings Align', action: 'wings_align' }
  ];
  

  oldselectedValues = {
    "0": {
        "title": "Marque",
        "value": ""
    },
    "1": {
        "title": "Set",
        "value": ""
    },
    "2": {
        "title": "Arcades",
        "value": ""
    },
    "3": {
        "title": "Nombre",
        "value": {
          "value": "",
          "Haut": "",
          "Bas": ""
      }
    },
    "4": {
        "title": "Port",
        "value": ""
    },
    "5": {
        "title": "Fréquence",
        "value": ""
    },
    "6": [],
    "7": {
        "title": "Auxiliaires Sélectionnés",
        "value": {
          "Sens Vertical": "",
          "Sens Antéro Postérieur": ""
      },
    "8": "",
    "9": "",
    }
  }

  selectedValues: { [questionIndex: number]: string } = {};

  numericAnswers: { [questionId: number]: { [label: string]: number } } = {};
  
  handleClick(questionIndex: number, option: string): void {
    // Toggle sélection
    console.log('questionIndex',questionIndex);
    console.log('option',option);
    if (this.selectedValues[questionIndex] === option) {
      this.selectedValues[questionIndex] = null;
    } else {
      this.selectedValues[questionIndex] = option;
    }
  }
  selectedTraitementType: string | null = null;

  selectTraitement(type: string) {
    this.selectedTraitementType = type;
  
    if (type === 'Aligneur') {
      this.currentStep = 0; // Reprendre le flux normal
    }
  
    // RCC et Bibagues peuvent rester bloqués ici en attendant les autres interfaces
  }
    triggerNextStep() {
    this.currentStep++;
    this.nextStepEvent.emit();
  }

  nextStep() {
      if (this.currentStep == 2) {
        this.triggerNextStep();
      }
      else{
      this.currentStep++;
      }


      // if(this.currentStep == 3 ) {
      //   this.currentStep++;
      // }
    
  }



  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  // reset() {
  //   this.currentStep = 1;
  //   this.selectedValues = {}; // Clear all selected values
  // }

  isSelected(step: number, value: string): boolean {
    return this.selectedValues[step] === value;
  }
  
  getNumericAnswer(label: 'Haut' | 'Bas'): number {
    const index = label === 'Haut' ? 6 : 7;
    const value = this.selectedValues[index];
    return value !== null && !isNaN(+value) ? +value : null;
  }
  
  setNumericAnswer(label: 'Haut' | 'Bas', value: number): void {
    const index = label === 'Haut' ? 6 : 7;
    this.selectedValues[index] = value.toString();
    console.log('index',index);
    
  }



  getQuestionGroups(): any[] {
    const groups = [];
    for (let i = 0; i < this.questions.length; i += 3) {
      groups.push(this.questions.slice(i, i + 3));
    }
    return groups;
  }
  getToothList(variable: any[]): string {
    // // console.log("variable",variable);
    
    // if (!variable || variable.length === 0) {
    //   return 'Aucun élément sélectionné.';
    // }
    return variable.map((v) => v.numteeth).join(', ');
  }

sections: any = [
  {
    title: 'Dents à déplacer',
    singleChoice: true,
    buttons: [
      { label: 'Dents à ne pas déplacer', variable: [], selected: false }
    ],
    buttons2: [
      { label: 'Déplacer toutes les dents', selected: false },
      { label: 'Déplacer incisivo-canines', selected: false }
    ]
  },
  {
    title: 'Taquets',
    singleChoice: true,
    buttons: [
      { label: 'Taquets UNIQUEMENT', variable: [], selected: false },
      { label: 'PAS DE TAQUETS SUR', variable: [], selected: false },
      { label: 'Taquets Lingual', variable: [], selected: false }

    ],
    buttons2: [
      { label: 'Taquets selon bastech', selected: false },
      { label: '0 taquets', selected: false }
    ]
  },
  {
    title: 'Stripping',
    singleChoice: true,
    buttons: [
      { label: 'Stripping uniquement', variable: [], selected: false },
      { label: 'Stripping selon bastech', selected: false },
      { label: 'Stripping incisivo-canins', selected: false }
    ],
    buttons2: [
      { label: '0 Stripping', selected: false }
    ]
  },
  {
    title: 'Découpe',
    singleChoice: false,
    buttons: [
      { label: 'Découpe élastiques', variable: [], selected: false },
      { label: 'Découpe bouton', variable: [], selected: false },
      { label: 'Crochet 3D', variable: [], selected: false}
    ],
    buttons2: []
  },
  {
    title: 'Cubes',
    singleChoice: false,
    buttons: [
      { label: 'Cube évolution', variable: [], selected: false },
      { label: 'Cube Dérotation', variable: [], selected: false }
    ],
    buttons2: []
  },
  {
    title: 'Pontic',
     singleChoice: false,
    buttons: [
      { label: 'Pontic', variable: [], selected: false }
    ],
    buttons2: [] // pas d'autres boutons pour Pontic
  }
];



pontic = { label: 'Pontic', variable: [] };


  buttons = [
    { label: 'Dents à ne pas déplacer', variable: [] },
    { label: 'Taquets UNIQUEMENT', variable: [] },
    { label: 'PAS DE TAQUETS SUR', variable: [] },
    { label: 'Taquets Lingual', variable: [] },
    { label: 'Stripping uniquement', variable: [] },
    { label: 'Découpe élastiques', variable: [] },
    { label: 'Découpe bouton', variable: [] },
    { label: 'Pontic', variable: [] },
    { label: 'Cube évolution', variable: [] },
    { label: 'Cube Dérotation', variable: [] }
  ];

  // Variable pour stocker la liste actuelle (celle qui est passée à app-dent)
  selectedVariable: any[] = [];
  selectedVariableIndex: number  ;

// Gérer clic sur un bouton (variable ou booléen)
currentSectionIndex: number | null = null;
currentButtonIndex: number | null = null;
isSelectedFromButtons2: boolean = false;


onButtonClick(sectionIndex: number, buttonIndex: number, type: 'buttons' | 'buttons2') {
  const section = this.sections[sectionIndex];
  const buttonArray = section[type];
  const clicked = buttonArray[buttonIndex];

  // Si le bouton cliqué est déjà actif -> on désactive l'active (il reste sélectionné)
  if (clicked.active) {
    clicked.active = false;
    // on garde clicked.selected = true (persistant)
    // Si tu veux permettre l'annulation complète (selected=false), on peut l'ajouter plus tard.
    return;
  }

  // 1) Désactiver active sur tous les boutons (il ne doit y avoir qu'un seul vert)
  this.sections.forEach(sec => {
    if (sec.buttons && Array.isArray(sec.buttons)) {
      sec.buttons.forEach(btn => btn.active = false);
    }
    if (sec.buttons2 && Array.isArray(sec.buttons2)) {
      sec.buttons2.forEach(btn => btn.active = false);
    }
  });

  // 2) Activer le bouton cliqué (vert) et marquer selected = true
  clicked.active = true;
  clicked.selected = true;

  // 3) Ne change pas les autres propriétés `selected` : ils restent true s'ils l'étaient
  //    (mais l'affichage dépendra de variable.length ou d'être a buttons2, via le HTML/CSS)

  // 4) Mettre à jour suivi si besoin
  this.isSelectedFromButtons2 = (type === 'buttons2');
  this.currentSectionIndex = sectionIndex;
  this.currentButtonIndex = buttonIndex;
  this.selectedVariable = clicked;
}














  // Méthode pour gérer les dents sélectionnées depuis <app-dent>
updateSelectedTeeth(teeth: string[]) {
  console.log('🦷 Dents reçues depuis <app-dent> :', teeth);

  if (this.currentSectionIndex === null || this.currentButtonIndex === null) {
    console.warn('⚠️ Aucun bouton sélectionné pour mettre à jour les dents.');
    return;
  }

  // Récupération de la section concernée
  const section = this.sections[this.currentSectionIndex];
  if (!section) {
    console.warn('❌ Section introuvable à l’index', this.currentSectionIndex);
    return;
  }

  // Vérifie si le bouton vient de "buttons" ou "buttons2"
  let button = null;
  if (section.buttons && this.currentButtonIndex < section.buttons.length) {
    button = section.buttons[this.currentButtonIndex];
  } else if (section.buttons2 && (this.currentButtonIndex - section.buttons.length) >= 0) {
    const adjustedIndex = this.currentButtonIndex - section.buttons.length;
    button = section.buttons2[adjustedIndex];
  }

  if (!button) {
    console.warn('❌ Bouton introuvable à l’index', this.currentButtonIndex);
    return;
  }

  // 🧩 Met à jour les dents sélectionnées
  button.variable = Array.isArray(teeth) ? teeth.slice() : [];
    if (!button.variable) {
      button.variable = [];
    }

  // 🧠 Garde une copie locale des dents sélectionnées
  this.selectedVariable = button.variable.slice();

  // 🔄 Mise à jour explicite dans la structure principale
  this.sections[this.currentSectionIndex] = { ...section };

  console.log(
    `✅ Mise à jour du bouton "${button.label}" dans la section "${section.title}" :`,
    button.variable
  );
  console.log('📘 this.sections (après maj):', JSON.parse(JSON.stringify(this.sections)));
}


  
  selectedAuxiliaireVertical: string | null = null;
  selectedAuxiliaireAnteroPost: string | null = null;
  
  // Méthode pour gérer la sélection des auxiliaires verticaux
  onVerticalAuxiliaireClick(action: string) {
    this.selectedAuxiliaireVertical = action;
    console.log(`Auxiliaire vertical sélectionné : ${action}`);
  }
  
  // Méthode pour gérer la sélection des auxiliaires antéro-postérieurs
  onAnteroPostAuxiliaireClick(action: string) {
    this.selectedAuxiliaireAnteroPost = action;
    console.log(`Auxiliaire antéro-postérieur sélectionné : ${action}`);
  }
  
  reset() {
    this.currentStep = 1;
    // this.selectedValues = {};
    this.selectedVariable = [];
    this.selectedVariableIndex = 0;
    this.selectedAuxiliaireVertical = null;
    this.selectedAuxiliaireAnteroPost = null;
  }

  send(){

    // console.log("SelectedValues : ",this.selectedValues );
    // console.log("Dents Sélectionnées : " ,this.buttons );
    // console.log("Auxiliaire vertical sélectionné : " ,this.selectedAuxiliaireVertical );
    // console.log("Auxiliaire antéro-postérieur sélectionné : ", this.selectedAuxiliaireAnteroPost );
    // console.log("old_plan_de_traitement : ", this.old_plan_de_traitement );

    let planDeTraitement = {
        "id": this.id ,
        "idPatient": this.idUser,
        "marqueLaboratoire": this.selectedValues[0],
        "etapeDeTraitement": this.selectedValues[1],
        "arcadesATraiter": this.selectedValues[2],
        "nombreAligneurs": this.selectedValues[3],
        "portPrevu": this.selectedValues[4],
        "changementPervu": this.selectedValues[5],
        "dentSelections":this.sections,
        "verticalAuxiliary": this.selectedAuxiliaireVertical,
        "anteroPosteriorAuxiliary": this.selectedAuxiliaireAnteroPost,
        "haut": this.selectedValues[6],
        "bas": this.selectedValues[7],
        "comment": this.remarks,
        "history": this.traitementAligneur ? this.traitementAligneur.history : null,
        "dateCreation":this.traitementAligneur ? this.traitementAligneur.dateCreation : null,
        "typePlan": "Home Made",
        "idPraticien": this.praticien.id,

    }
    console.log("planDeTraitement : ", planDeTraitement );
    // console.log("button : ", this.buttons );
    this.planDeTraitementService.setPlanDeTraitement(planDeTraitement).subscribe((response: Blob) => {
    console.log("response planDeTraitementService  : ", response );
      this.traitement = response;

    // this.printPlanDeTraitement();
    this.getPlantDeTraitement(this.idUser);
      
    });
  }

hasStartupType(): boolean {
  if (!this.listeoftraitement || this.listeoftraitement.length === 0) {
    return false;
  }
  return this.listeoftraitement.some(item => item.typePlan === 'Startup');
}



getSelectionText(item: any, title: string): string {  
  if (!item || !item.dentSelections) return '—';

  // Trouver la section correspondant au titre (ex: "Taquets", "Stripping", etc.)
  const section = item.dentSelections.find((s: any) => s.title === title);
  if (!section) return '—';

  // Fusionner buttons et buttons2
  let allButtons: any[] = [];
  if (section.buttons) allButtons = allButtons.concat(section.buttons);
  if (section.buttons2) allButtons = allButtons.concat(section.buttons2);

  // Garder uniquement les boutons sélectionnés
  const selectedButtons = allButtons.filter((b: any) => b.selected);
  if (selectedButtons.length === 0) return '—';

  // Construire le texte pour chaque bouton sélectionné
  const result = selectedButtons.map((b: any) => {
    // Extraire les numéros de dents si disponibles
    if (b.variable && b.variable.length > 0) {
      const teethNumbers = b.variable.map((v: any) => v.numteeth).join(', ');
      return `${b.label} sur ${teethNumbers}`;
    } else {
      return b.label;
    }
  });

  // Retourner une chaîne lisible, séparée par des virgules
  return result.join(', ');
}






  remarks = '';
    traitementCommentaire = "" ;
    updateComment(selectedValues: any) {
        console.error("selectedValues",selectedValues);

      // On suppose que selectedValues.id contient l'ID du traitement
      const id = selectedValues[10];
      const comment = selectedValues[9]; // ou selectedValues.comment si ton objet a une clé "comment"

      if (!id) {
        console.error("ID du traitement introuvable !");
        return;
      }

      if (comment === undefined || comment === null) {
        console.warn("Commentaire vide, mise à jour ignorée.");
        return;
      }

      this.planDeTraitementService.updateCommentAligneur(id, comment)
        .subscribe({
          next: () => {
            console.log(`Commentaire du plan ${id} mis à jour avec succès`);
          },
          error: (err) => {
            console.error(`Erreur lors de la mise à jour du plan ${id}`, err);
          }
        });
    }

  printPlanDeTraitement() {
        console.log("selectedValues : ", this.selectedValues );

    const printElement = document.getElementById('planDeTraitement');
    if (printElement) {
      // Afficher l'élément en retirant l'attribut hidden
      printElement.hidden = false;
  
      // Créer une fenêtre d'impression
      const printWindow = window.open('', '_blank', "width="+ screen.width + ",height=" + screen.height);
      if (printWindow) {
   printWindow.document.write(`
          <html>
            <head>
              <title>Résumé du Plan de Traitement ${this.userSelected}</title>
              <style>
                 body {
                    font-family: Arial, sans-serif;
                    margin: 0;
                    padding: 0;
                    background-color: #f9f9f9;
                    color: #333;
                  }
                  .container {
                    width: 80%;
                    margin: 20px auto;
                    background: #fff;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                    border-radius: 8px;
                    padding: 20px;
                  }
                  .header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    border-bottom: 2px solid #58b3dd;
                    padding-bottom: 10px;
                  }
                  .header h1 {
                    color: #58b3dd;
                    font-size: 24px;
                    margin: 0;
                  }
                  .header .date {
                    font-size: 14px;
                    color: #777;
                  }
                  .section {
                    margin-bottom: 10px;
                    padding: 15px;
                    background-color: #f1f9ff;
                    border-left: 5px solid #58b3dd;
                    border-radius: 4px;
                  }
                  .section h2 {
                    font-size: 20px;
                    margin-bottom: 10px;
                    color: #333;
                  }
                  .section p {
                    margin: 5px 0;
                    line-height: 1.6;
                  }
                   th, td {
                  border: 1px solid #3b82f6;
                  padding: 8px;
                  text-align: center;
                  vertical-align: top;
                }
            
                th {
                  background-color: #f0f8ff;
                  font-weight: bold;
                }
            
                td {
                  white-space: pre-line;
                }
              </style>
            </head>
            <body>${printElement.outerHTML}</body>
            <script type="text/javascript" defer>
              setTimeout(function() {
                  window.print();
                  window.close();
              }, 1000);
            </script>
          </html>
        `);
      }
      printWindow.document.close();
      // Réappliquer l'attribut hidden après impression
      printElement.hidden = true;
      this.downloadAsPdf();
    } else {
      console.error('Élément à imprimer introuvable.');
    }
  }

  downloadAsPdf() {
    var printContents = document.getElementById("planDeTraitement").innerHTML;
  let html = `
          <html>
            <head>
              <title>Résumé du Plan de Traitement ${this.userSelected}</title>
              <style>
                 body {
                    font-family: Arial, sans-serif;
                    margin: 0;
                    padding: 0;
                    background-color: #f9f9f9;
                    color: #333;
                  }
                  .container {
                    width: 80%;
                    margin: 20px auto;
                    background: #fff;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                    border-radius: 8px;
                    padding: 20px;
                  }
                  .header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    border-bottom: 2px solid #58b3dd;
                    padding-bottom: 10px;
                  }
                  .header h1 {
                    color: #58b3dd;
                    font-size: 24px;
                    margin: 0;
                  }
                  .header .date {
                    font-size: 14px;
                    color: #777;
                  }
                  .section {
                    margin-bottom: 10px;
                    padding: 15px;
                    background-color: #f1f9ff;
                    border-left: 5px solid #58b3dd;
                    border-radius: 4px;
                  }
                  .section h2 {
                    font-size: 20px;
                    margin-bottom: 10px;
                    color: #333;
                  }
                  .section p {
                    margin: 5px 0;
                    line-height: 1.6;
                  }
                    th, td {
                      border: 1px solid #3b82f6;
                      padding: 8px;
                      text-align: center;
                      vertical-align: top;
                    }
                
                    th {
                      background-color: #f0f8ff;
                      font-weight: bold;
                    }
                
                    td {
                      white-space: pre-line;
                    }
              </style>
            </head>
            <body>${printContents}</body>
            <script type="text/javascript" defer>
              setTimeout(function() {
                  window.print();
              }, 1000);
            </script>
          </html>
        `;

          
    this.pdfService.htmlToPdf(html).subscribe((response: Blob) => {
      const blob = new Blob([response], { type: 'application/pdf' });
      this.saveToBasePhoto(blob);
    });
  }
  
  async saveToBasePhoto(blob: any) {
    // const arrayBuffer = await blob.arrayBuffer();
    // const destName = sha1(blob.text());
    const destName = "Aligneur_" + localStorage.getItem('idPatient') + generateRandomString(12);

    pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/build/pdf.worker.min.js";
    const pdfDoc = await pdfjsLib.getDocument({ url: URL.createObjectURL(blob) }).promise.then(async (pdf) => {
      const page = await pdf.getPage(1);
      const canvas = document.createElement('canvas');
      const context = canvas.getContext("2d");
      const viewport = page.getViewport({ scale: 1 });
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      const renderContext = {
        canvasContext: canvas.getContext('2d'),
        viewport: viewport,
      };
      await page.render(renderContext).promise.then( async () => {
        const imageDataURL = canvas.toDataURL('image/jpeg', 25);
        const image = imageDataURL.replace("data:image/jpeg;base64,", "");
        await this.insertObjet(
          destName + ".pdf", ".pdf", +localStorage.getItem('idPatient'), image, 141, 200, 0, 0, null, 1, destName + ".pdf", "", Context.folder + localStorage.getItem('idPatient'), "", "", "", 0, localStorage.getItem('idPatient')
        ).toPromise();
        this.isLoading = false;
        this.isDisabled = false;

      });
    });  

    var form = new FormData();
    form.append("file", blob);
    this.objetService
        .saveImage(destName + ".pdf", Context.folder + localStorage.getItem('idPatient'), form)
        .subscribe();
  }


  siteRCC() {
    if(this.userDetails.idRcc != null) {
      window.open(`${this.siteRCCService.getSiteUrl()}/${this.userDetails.idRcc}`);
    }
    else {
      this.customLoading.presentLoading().then(e => {
        this.siteRCCService.addPatient({id: this.userDetails.id_personne, cabinet: Context.cabinet}).subscribe(
          (value: any) => {
            this.userDetails.idRcc = value.id;
            window.open(`${this.siteRCCService.getSiteUrl()}/${value.id}`);
          },
          (error: HttpErrorResponse) => console.error(error),
          () => this.customLoading.dismissLoading()
        )
      });
    }
  }

}
function generateRandomString(length: number): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  return result;
}
